import $ from 'cash-dom'
import _ from 'lodash'
import {fmt, s, greyscale, palette, rewind, ffwd, cancel, offset, sfc32, quadMinMax, bezierMinMax} from './util.js'
import {spring, tween, easing, scrollPage, getJSON, postJSON, getQuadraticPoint} from './util.js'

import Loop from './loop.js'
import Arc from './arc.js'
import Galley from './galley.js'
import Matrix from './matrix.js'
import Plane from './plane.js'
import Net from './net.js'
import Thermometer from './thermometer.js'
import Teeth from './teeth.js'


class Library{
  constructor(sel){
    this.dom = $(sel)
    this.setMode = this.setMode.bind(this)
    this.dom.on('change', 'select.view', this.setMode)
  }

  setMode(e){
    let mode = $(e.target).val(),
        gfx = mode=='cover' ? 'cover.jpg' : `${mode}.svg`

    $(e.target).parent('.menu').attr('data-mode', e.target.selectedOptions[0].textContent)

    $("#corpus").attr('class', mode)
    $('#corpus li img').each((i,elt) => {
      let img = $(elt),
          slug = img.data('slug')
      if (slug) img.attr('src', `${slug}/${gfx}`)
    })

    this.dom.find('li').each((i,elt) => {
      let button = $(elt)
      button.toggleClass('active', button.data('mode')==mode)
    })
  }
}

class Viz{
  constructor(){
    let book = BOOK,
        {depth} = book.stats

    console.log({book})

    this.setDepth = this.setDepth.bind(this)
    this.atDepth = depth
    this.spring = spring({at:depth, to:depth, step:this.setDepth})

    $(".diagram.static").removeClass('static')

    $('#slider input').on('input', e => {
      let val = _.toNumber(e.target.value)
      if (this.play){
        this.play = this.play.stop()
        this.spring.set(this.atDepth)
        this.spring.start()
      }
      if (this.spring) this.spring.to = val
    }).on('mousedown', e=>{
      $('#book').addClass('dragging')
      $('#slider').on('wheel', cancel)
    }).on('mouseup', e=>{
      $('#book').removeClass('dragging')
      $('#slider').off('wheel', cancel)
    })

    $('nav .tick:last-child').addClass('current')

    $('section h1 a').on('click', e => {
      let name = $(e.target).attr('href').replace(/^#/,''),
          target = $(`a[name=${name}]`)
      scrollPage({to:target})
    })

    this.play = false
    $("nav .label").on('click', e => {
      let idx
      if (this.play) this.play.stop()

      this.spring.stop()
      this.spring.set({at:0, to:0})
      this.play = tween({
        at:0, to:depth, dur:500*depth, ease:'linear',
        step:at => {
          this.setDepth(at)
        },
        complete:() => {
          this.play = false
          this.spring.set(depth)
          this.spring.start()
        }
      })

      // scroll nav to the top if it hasn't stuck yet
      let minY = $("nav").offset().top
      if (window.scrollY < minY){
        scrollPage({to:minY})
      }
    })

    this.sections = {
      net: new Net({book}),
      loop: new Loop({book, angles:{min:180, run:180}, radii:{min:25, perPg:1.2}}),
      arc: new Arc({book, page:{spacing:4, width:2.5, height:5}}),
      galley: new Galley(book),
      matrix: new Matrix(book),
      plane: new Plane(book),
      // teeth: new Teeth(book)
    }

    for (const [name, viz] of Object.entries(this.sections)){
      viz.attach(`#${name}`)
      new IntersectionObserver(
        ([e]) => viz.visible = e.isIntersecting
      ).observe(document.querySelector(`#${name} .diagram`))
    }

    new IntersectionObserver(
      ([e]) => e.target.classList.toggle('stuck', e.intersectionRatio < 1),
      {rootMargin: '-1px 0px 100% 0px', threshold: [1]}
    ).observe(document.querySelector('main nav'))

  }

  setDepth(depth){
    depth = _.min([depth, BOOK.stats.depth])

    // show branches & pages that are fully drawn at this depth
    $(".diagram > svg > g").attr('class', _.range(Math.floor(depth)+1).map(d=>"depth-"+d).join(' '))

    // animate partial branches for current depth fraction
    for (const viz of Object.values(this.sections)){
      if (viz.visible) viz.setDepth(depth)
    }


    // update nav
    let d = Math.round(depth)
    if (d != this.atDepth){
      this.atDepth = d
      $('nav > .label span').text(`${d} choice${s(d)}`);

      $('nav .tick').each((i, elt) => {
        elt.classList.toggle('current', i == d)
      })

      if (this.play) $("#slider input").val(d)
    }
  }

}


export{Viz, Library, Loop, Arc, Galley, Matrix, Plane, Net, Thermometer, Teeth}
